/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Fact_TruncatedInputs */



/**
* | output |
* | --- |
* | "The answer was cut off at the size limit" |
*
* @param {Private_Models_Fact_TruncatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_fact_truncated = /** @type {((inputs?: Private_Models_Fact_TruncatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Fact_TruncatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Antwort wurde an der Größengrenze abgeschnitten")
	return /** @type {LocalizedString} */ ("The answer was cut off at the size limit")
});